import { Box, Button, Icon, Radio, Text } from 'native-base'
import { useState } from 'react'
import { useDesktopBreakpoint } from '../../../../../domain/services/useBreakpoint'
import { useCompleteStepMutation } from '../../../queries/voyageQueries'
import FaIcon from '../../_shared/FaIcon'

const fields = [
  {
    value: 'yes',
    text: 'Yes',
  },
  {
    value: 'maybe',
    text: 'A little',
  },
  {
    value: 'no',
    text: 'Nope',
  },
]

const RadioButton = ({ item, selected }) => (
  <Box
    width="100%"
    p={3}
    my={item.value === 'maybe' ? 3 : 0}
    borderRadius="10px"
    borderColor={item.value === selected ? 'primary.900' : 'muted.200'}
    borderWidth={1}>
    <Radio
      p={1}
      _checked={{
        backgroundColor: 'secondary.700',
        borderColor: 'secondary.700',
        size: 'sm',
        width: '20px',
        height: '20px',
      }}
      size="sm"
      value={item.value}
      icon={<Icon as={<FaIcon name="check" size={12} color="white" />} />}
      my={1}>
      <Text fontSize="16px" color="primary.900">
        {item.text}
      </Text>
    </Radio>
  </Box>
)

const StepCompletionForm = ({ stepId }) => {
  const completeStepMutation = useCompleteStepMutation()
  const isDesktop = useDesktopBreakpoint()
  const [value, setValue] = useState('')

  const completeStep = () => {
    completeStepMutation.mutation.mutate(stepId)
  }

  return (
    <Box width={!isDesktop ? '100%' : '342px'} alignSelf="center">
      <Box
        mt={4}
        mb={2}
        borderRadius="20px"
        p={4}
        borderWidth={1}
        borderColor="grey.200">
        <Text mb={4} fontSize="18px" fontWeight={700} color="primary.900">
          Was this helpful?
        </Text>
        <Radio.Group
          name="myRadioGroup"
          accessibilityLabel="favorite number"
          value={value}
          onChange={(value) => {
            setValue(value)
          }}>
          {fields.map((item) => (
            <RadioButton item={item} selected={value} key={item.value} />
          ))}
        </Radio.Group>
      </Box>
      <Button isDisabled={!value} onPress={completeStep}>
        <Text fontSize="16px" fontWeight={500} color="white">
          Finish
        </Text>
      </Button>
    </Box>
  )
}

export default StepCompletionForm
